export const NOTIFICATIONS_PAGE_KEY = 'notifications';
export const POSTS_PAGE_KEY = 'my-posts';
